import type { FastifyRequest } from 'fastify'

/**
 * Default key generator for Fastify.
 * Respects `trustProxy` config — when enabled, `request.ip` already
 * reflects the real client IP from X-Forwarded-For.
 * Falls back to raw X-Forwarded-For header when trustProxy is off.
 */
export const extractIp = (req: FastifyRequest): string => {
  const fwd = req.headers['x-forwarded-for']
  if (typeof fwd === 'string') return fwd.split(',')[0]!.trim()
  if (Array.isArray(fwd) && fwd.length > 0) return fwd[0]!.trim()
  return req.ip ?? req.socket.remoteAddress ?? 'unknown'
}
